export function treeTableConfig({ compact, spacing }) {
    return compact
        ? {}
        : {
            bodyCell: {
                padding: `${spacing.verticalSpacing.vertWhiteSpacingxs}px ${spacing.horizontalSpacing.horizWhiteSpacingsm}px`
            }
        };
}
